/* ----- code generated do not modify ----- */
var components_combo_box_locale26 = {
  "buttonLabel": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043E\u0432");
      }
    }), " \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      "true": function _true() {
        return "\u0412\u0432\u0435\u0434\u0435\u043D\u043D\u0430\u044F \u0433\u0440\u0443\u043F\u043F\u0430 ".concat(args.groupTitle, ", \u0441 ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043E\u043C");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u043C\u0438");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      "true": ", \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u043C\u0438",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", \u0432\u044B\u0431\u0440\u0430\u043D\u043E");
  }
};

export { components_combo_box_locale26 as default };
//# sourceMappingURL=ru-RU.esm.js.map
